module.exports = __webpack_public_path__ + "img/jands-webinar-bw.de3390f9.svg";